const $ = jQuery.noConflict()

var self = module.exports = {

  init: function(menu) {

    // Prepend title from parent link text
    $(menu).find('li').each(function(){
      if ($(this).hasClass('menu-item-has-children')) {
        var title = $(this).find('a').first().text()
        var submenu = $(this).find('.sub-menu')

        // $(submenu).prepend('<li class="h4 hidden-sm-down" style="margin-bottom: 1rem;">' + title + '</li>')
        // $(submenu).append('<div></div>')

        // var items = $(submenu).find('li')
        // var div = $(submenu).find('div').first()
        // $(items).each(function() {
        //   // $(this).appendTo(div)
        // })
      }
    })

    // Add click event to apply active class
    $(menu + ' li a').on('click',function(){
      $(menu + ' li a').removeClass('active')
      $(this).addClass('active')
    })

  },

  events: {
    click: function(trigger) {

    }
  },

  service: {
    bodyClass: function() {

    }
  }
}
